export const AVAILABILITY_STATUS_IDLE = 'Available';
export const AVAILABILITY_STATUS_ON_ASSIGNMENT = 'Driving';
export const AVAILABILITY_STATUS_ON_ABSENCE = 'On absence';
export const AVAILABILITY_STATUS_ON_PROTECTION = 'On protection';
export const AVAILABILITY_STATUS_RESTING = 'Resting';
export const AVAILABILITY_STATUS_UNKNOWN = 'Unknown';
